module.exports = __webpack_public_path__ + "media/images/HiPrecision-a86996fc472f84ee227478a888374d8b.png";